import React, {useState, useEffect, useRef} from 'react'
import { Alert, Button, Col, Row, ListGroup, ListGroupItem, Card, CardBody, CardHeader } from 'reactstrap'
import {
Nav,
Navbar,
NavbarBrand,
NavbarText,
NavbarToggler as NavbarTogglerBase,
NavItem,
NavLink
} from 'reactstrap'
import { purchaseMachine } from 'containers/purchase/purchase_machine'
import PriceSummary from 'components/price_summary'
import { useMachine } from '@xstate/react'
import productMachineConfig from 'containers/purchase/machines/product_machine_config'
import {stepConfig, isLastStep, currentStep, stepStatus} from 'utils/step_utils'
import PurchaseWizard from 'containers/purchase/purchase_wizard'
import ProductHeader from 'containers/purchase/partials/product_header'
import PurchaseWrapper from 'ui/purchase_wrapper'
import useLayout from 'utils/hooks/use_layout'
import { useTranslation } from 'react-i18next'
import stopSales from 'img/stop-sales'
import {isMobile, isMobileOnly} from 'react-device-detect'
import cn from 'classnames'
import Page from 'ui/page'
import Modal from 'ui/modal'
import parse from 'react-html-parser'
import SummaryModal from 'containers/purchase/partials/summary_modal'
import styled from 'styled-components'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import ProductMasonry from './product_masonry'
import Features from 'containers/list/info_types/product_details/features'
import StartingPoint from 'containers/list/info_types/product_details/starting_point'
import {scrollIntoView} from 'scroll-js'
import goforajourneyLogo from 'goforajourney/img/goforajourney-logo-h'
import Rating from 'ui/rating'

const PageStyles = styled.div.attrs({
  className: ''
})`
  h2 {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 1em;
  }

  ul {
    margin: 0;
  }
`

const ProductTitle = styled.h1.attrs({
  className: 'font-weight-bold'
})`
  font-size: 2em;
`

const ProductBreadcrumb = styled.div.attrs({
  className: 'mb-2'
})`
  font-weight: 500;
  font-size: 1em;
`

const BreadcrumbArrow = () => {
  return (
    <span className="text-primary">></span>
  )
}

const ProductHeaderB2c = (props) => {
  const {product, product_info, destination, endpoints} = props
  const {title} = product
  const {headline} = destination
  const {rating} = product_info

  return (
    <div className="mb-4">
      <ProductTitle>
        {title}
      </ProductTitle>
      <ProductBreadcrumb>
        <a href={endpoints.home}>Home</a> <BreadcrumbArrow/> <a href={endpoints.products}>{headline}</a> <BreadcrumbArrow/> {title}
      </ProductBreadcrumb>
      <Rating value={rating}/>

      {false &&
        <div className="container mt-4">
          <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={50}
            totalSlides={3}
            visibleSlides={1}
          >
            <Slider className="carousel slide">
              <Slide index={0}>
                <img
                  src="https://obadmin-production.s3.eu-central-1.amazonaws.com/c6thg3oelurx8zh2h4cgg8nr757f"
                  className="d-block w-100"
                  alt="Slide 1"
                />
              </Slide>
              <Slide index={1}>
                <img
                  src="https://obadmin-production.s3.eu-central-1.amazonaws.com/c6thg3oelurx8zh2h4cgg8nr757f"
                  className="d-block w-100"
                  alt="Slide 2"
                />
              </Slide>
              <Slide index={2}>
                <img
                  src="https://obadmin-production.s3.eu-central-1.amazonaws.com/c6thg3oelurx8zh2h4cgg8nr757f"
                  className="d-block w-100"
                  alt="Slide 3"
                />
              </Slide>
            </Slider>
            <div className="d-flex justify-content-between mt-2">
              <ButtonBack className="btn btn-danger">Back</ButtonBack>
              <ButtonNext className="btn btn-danger">Next</ButtonNext>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <DotGroup className="btn-group" />
            </div>
          </CarouselProvider>
        </div>
      }
    </div>
  )
}

const NotificationModal = (props) => {
  const {notification, notification_type, modal, toggle} = props

  if (notification && notification_type == 'popup') {
    return (
      <Modal
        isOpen={modal}
        toggle={toggle}
      >
        {parse(notification)}
      </Modal>
    )
  } else {
    return null
  }
}

const scrollToSection = (ref) => {
  if (ref.current) {
    scrollIntoView(ref.current, document.body, { block: 'start', behavior: 'smooth' })
  }
}

const ProductPurchase = (props) => {
  const {product_id, endpoints, product, product_info, related_products, cart_params} = props
  const [notificationModal, setNotificationModal] = useState(true)
  const [cartModal, setCartModal] = useState(false)
  const toggleNotificationModal = () => setNotificationModal(!notificationModal)
  const [isFixed, setIsFixed] = useState(false);

  const scrollToPurchase = () => scrollToSection(purchaseRef)

  const StickyBar = (props) => {
    const {location = 'top', onClickButton, isFixed, product, product_info, className, menu_props} = props
    const {featured_price_label} = product
    const {title} = product_info
    const {root} = menu_props

    return (
      <nav
        className={cn([`navbar navbar-expand-lg navbar-light shadow ${location == 'top' ? "fixed-top" : "fixed-bottom"}`], className)}
        style={{background: 'white'}}
      >
        <div className="container">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="font-weight-bold d-none d-md-block w-100">
              <div className="mb-2">
                <a href={root}><img width="180px" src={goforajourneyLogo}/></a>
              </div>
              <div>{title}</div>
            </div>
            <div className="d-flex w-100 flex-column flex-md-row justify-content-center justify-content-md-end align-items-center">
              <div className="mr-0 mr-md-3" style={{fontWeight: '500'}}>From {featured_price_label}</div>
              <Button
                size="md"
                color="primary"
                className="shadow rounded-lg px-3 py-2 d-flex justify-content-center align-items-center"
                style={{fontWeight: '500'}}
                onClick={() => onClickButton()}
              >
                <i style={{fontSize: '1.35em'}} className="far fa-calendar-alt mr-2 pr-1"/> Check availability
              </Button>
            </div>
          </div>
        </div>
      </nav>
    )
  }

  const StickyHeader = (props) => {
    const ref = useRef(null)

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (isMobile) {
            setIsFixed(!entry.isIntersecting)
          } else {
            setIsFixed(entry.boundingClientRect.top < 0 && !entry.isIntersecting)
          }
        },
        { threshold: 0 }
      );

      if (ref.current) observer.observe(ref.current)

      return () => observer.disconnect()
    }, [])

    return (
      <div>
        <div ref={ref} style={{ height: "1px", background: "transparent" }} className="text-center"/>

        {isFixed &&
          <StickyBar location={isMobile ? 'bottom' : 'top'} {...props} isFixed={isFixed} onClickButton={() => scrollToPurchase()}/>
        }
      </div>
    )
  }

  const {i18n} = useTranslation()
  const config = productMachineConfig(props.machine, props)
  const stepsConfig = config.steps

  const machine = useMachine(purchaseMachine(config), {
    context: {
      endpoints: endpoints,
      product_id: product_id,
      timezone: product.local_timezone,
      currency: product.currency,
      related_products: related_products
    }
  })

  const mode = useLayout()

  const [current, send] = machine
  const {reservation_ready, cart, redirect_url} = current.context

  useEffect(() => {
    if (current.value == 'reserved') {
      if (cart_params.enable_cart) {
        setCartModal(true)
      } else {https://www.twitch.tv/jino_destroyer
        document.location.href = redirect_url
      }
    }
  }, [current.value])

  const currentStepConfig = stepConfig(stepsConfig, current.value)

  const {error} = current.context
  const {product_status, title, notification, notification_type} = props.product

  const PurchaseError = ({error}) => (
    <div id="purchase-error">
      {error &&
        <Alert color="danger">{error}</Alert>
      }
    </div>
  )

  const ReservationButton = () => {
    return (
      <Button
        disabled={!reservation_ready}
        size={'lg'}
        style={{padding: '9px 62px'}}
        color='danger'
        className={cn('text-white', isMobile ? 'btn-block' : '')}
        onClick={() => send('RESERVATION_REQUEST')}
      >
        {i18n.t('product_purchase.reservation_button')}
      </Button>
    )
  }

  if (product_status != 'active') {
    return (
      <PurchaseWrapper mode={mode} className="text-center p-3 container">
        <div className="alert alert-warning" role="alert">
          <h2>{title}</h2>
          <p className="m-0">{i18n.t('product_purchase.stop_sales_description')}</p>
          <img src={stopSales}/>
        </div>
      </PurchaseWrapper>
    )
  }

  const {featured_price_label} = product
  const {featured_image, images, short_description, long_description, return_policy_text, starting_point, hooks, highlights} = product_info
  const buttonRef = useRef()
  const purchaseRef = useRef()

const Highlights = ({highlights}) => {
  const {i18n} = useTranslation()
  const highlightsArray = JSON.parse(highlights)

  if (!highlightsArray || (highlightsArray && highlightsArray.length < 1) ) { return '' }

  return (
    <React.Fragment>
      <h2>{i18n.t('product_info.highlights')}</h2>
      <ul className="m- p-0" style={{listStyleType: 'none'}}>
        {highlightsArray.map((item) =>
          <li className="arrow-left">
            <i className='fas fa-chevron-right text-primary mr-1'/> {parse(item)}
          </li>
        )}
      </ul>

    </React.Fragment>
  )
}

  const Hooks = ({hooks}) => {
    const hooksArray = JSON.parse(hooks)

    if (!hooksArray || (hooksArray && hooksArray.length < 1) ) { return '' }

    return (
      <Row>
        <Col className="mt-3">
          <ul className="m-0 p-0" style={{listStyle: 'none'}}>
            {hooksArray.map((item) =>
              <li className="rounded-lg border py-1 mb-3" style={{fontSize: '0.85em'}}>
                <i className='fa fa-check text-primary mr-1'/> {parse(item)}
              </li>
            )}
          </ul>
        </Col>
      </Row>
    )
  }

  return (
    <React.Fragment>
      <Page {...props}>
        <ProductHeaderB2c {...props}/>
        <ProductMasonry featured_image={featured_image} images={images}/>
        <PageStyles>
          <Row className="mt-5">
            <Col xs="12" md="8">
              <Row>
                <Col>
                  <p>
                    {parse(short_description)}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Highlights highlights={highlights}/>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col>
                  <Features {...product_info}/>
                </Col>
              </Row>
              {starting_point &&
                <Row className="mt-4">
                  <Col>
                    <StartingPoint {...starting_point}/>
                  </Col>
                </Row>
              }
              <Row className="mt-4">
                <Col>
                  <h2>{i18n.t('product_info.description_title')}</h2>
                  <p>
                    {parse(long_description)}
                  </p>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <h2>
                    {i18n.t('product_info.return_policy_title')}
                  </h2>
                  <p className="policy-text">{parse(return_policy_text)}</p>
                </Col>
              </Row>
            </Col>
            <Col xs="12" md="4">
              <Card className="shadow-lg rounded-lg d-none d-md-block">
                <CardBody className="text-center" style={{fontSize: '1.5em'}}>
                  <span className="font-weight-bold ">From {featured_price_label}</span>
                  <Hooks hooks={hooks}/>
                  <div ref={buttonRef} className="d-flex justify-content-center">
                    <Button
                      size="lg"
                      color="primary"
                      className="shadow mt-1 rounded-lg px-5 py-3 d-flex justify-content-center align-items-center d-none d-md-block"
                      style={{fontWeight: '500'}}
                      onClick={() => scrollToSection(purchaseRef)}
                    >
                      <i style={{fontSize: '1.35em'}} className="far fa-calendar-alt mr-2 pr-1"/> Check availability
                    </Button>
                  </div>
                </CardBody>
              </Card>
              <StickyHeader {...props}/>
            </Col>
          </Row>
          <Row >
            <Col>
              <div ref={purchaseRef} className="mb-5"/>
              <hr/>
              <Card className="rounded-lg mt-5">
                <CardHeader>
                  <h3 style={{fontSize: '1.2em'}} className="font-weight-bold text-center m-0">
                    {i18n.t('format:actions.book_now')}
                  </h3>
                </CardHeader>
                <CardBody className="text-center">
                <PurchaseError error={error}/>

                  {Object.keys(stepsConfig).map((step) => {
                    const Module = stepsConfig[step].component
                    const moduleStatus = stepStatus(stepsConfig, step, currentStep(current.value))

                    return (
                      <Module
                        key={step}
                        config={props}
                        machine={machine}
                        status={moduleStatus}
                        isLastStep={isLastStep(stepsConfig, current.value)}
                        stepConfig={currentStepConfig}
                        {...stepsConfig[step].componentProps}
                      />
                    )
                  })}

                  <div className="d-flex flex-column-reverse flex-md-row-reverse align-items-start">
                    {!config.hideReservatioButton && isLastStep(stepsConfig, current.value) &&
                      <ReservationButton/>
                    }

                    <PriceSummary machine={machine}/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </PageStyles>
      </Page>
    </React.Fragment>
  )
}

export default ProductPurchase
